import { render, staticRenderFns } from "./ThePersonalSupportFaq.vue?vue&type=template&id=09c112ce&"
import script from "./ThePersonalSupportFaq.vue?vue&type=script&lang=js&"
export * from "./ThePersonalSupportFaq.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalSupportFaq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports